import React from "react";
import PropTypes from "prop-types";

import "./lineSkeleton.scss";

const LineSkeleton = ({ width = "100%", height = "24px" }) => {
  return (
    <div className="skeleton-line" style={{ width: width, height: height }} />
  );
};
LineSkeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};

export default LineSkeleton;
